export const descricao_pqr = {
  p: '1. Frequência Alta de Saída',
  q: '2. Frequência Média de Saída',
  r: '3. Frequência Baixa de Saída',
}

export const descricao_xyz = {
  x: '3. Faturamento Baixo',
  y: '2. Faturamento Médio',
  z: '1. Faturamento Elevado',
}

export const coberturas_padrao = [
  {
    pqr: 'P',
    xyz: 'Z',
    classificacao_popularidade: descricao_pqr.p,
    classificacao_criticidade: descricao_xyz.z,
    tempo_cobertura: 0
  },
  {
    pqr: 'P',
    xyz: 'Y',
    classificacao_popularidade: descricao_pqr.p,
    classificacao_criticidade: descricao_xyz.y,
    tempo_cobertura: 0
  },
  {
    pqr: 'P',
    xyz: 'X',
    classificacao_popularidade: descricao_pqr.p,
    classificacao_criticidade: descricao_xyz.x,
    tempo_cobertura: 0
  },

  {
    pqr: 'Q',
    xyz: 'Z',
    classificacao_popularidade: descricao_pqr.q,
    classificacao_criticidade: descricao_xyz.z,
    tempo_cobertura: 0
  },
  {
    pqr: 'Q',
    xyz: 'Y',
    classificacao_popularidade: descricao_pqr.q,
    classificacao_criticidade: descricao_xyz.y,
    tempo_cobertura: 0
  },
  {
    pqr: 'Q',
    xyz: 'X',
    classificacao_popularidade: descricao_pqr.q,
    classificacao_criticidade: descricao_xyz.x,
    tempo_cobertura: 0
  },

  {
    pqr: 'R',
    xyz: 'Z',
    classificacao_popularidade: descricao_pqr.r,
    classificacao_criticidade: descricao_xyz.z,
    tempo_cobertura: 0
  },
  {
    pqr: 'R',
    xyz: 'Y',
    classificacao_popularidade: descricao_pqr.r,
    classificacao_criticidade: descricao_xyz.y,
    tempo_cobertura: 0
  },
  {
    pqr: 'R',
    xyz: 'X',
    classificacao_popularidade: descricao_pqr.r,
    classificacao_criticidade: descricao_xyz.x,
    tempo_cobertura: 0
  },
];
